function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretDownSmall = function SvgCaretDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "caret-down-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M8.00098 6.25L4.50098 9.75L1.00098 6.25",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgCaretDownSmall.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCaretDownSmall"
};
export default SvgCaretDownSmall;